/* Hide header on scroll */
// $(document).on("scroll", function (e) {
//     if ($(window).width() > 1024) {
//         if ($(this).scrollTop() > 200) {
//             $('header .groupbar-dk').slideUp(250);
//         } else {
//             $('header .groupbar-dk').slideDown(250);
//         }
//     }
// });

/* Toggle hamburger navbar */
$("#hamburger").on("click", function () {
    $(this).toggleClass("is-active");
});

/* Funzione SetCookie */
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/* Funzione GetCookie */
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = document.cookie; // Do not decode the whole cookie string yet
    var ca = decodedCookie.split(";");

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }

        // Check if the cookie starts with the desired name
        if (c.indexOf(name) == 0) {
            // Try to decode only the value part of the cookie
            try {
                return decodeURIComponent(c.substring(name.length, c.length));
            } catch (error) {
                console.error("Error decoding cookie value for '" + cname + "':", error);
                return ""; // Return an empty string or handle error as needed
            }
        }
    }
    return "";
}


/* Gestione Avvisi */
$("#close_avviso").on("click", function () {
    $("#avviso").css("display", "none");
    setCookie("avviso", 1, 1);
});

initAvviso();

function initAvviso() {
    var avviso = getCookie("avviso");
    if ($("#avviso").length > 0) {
        if (avviso == 1) {
            $("#avviso").css("display", "none");
        } else {
            $("#avviso").css("display", "block");
        }
    }
}

/* Gestione Popup */
$("#close_popup").on("click", function () {
    $("#popup").css("display", "none");
    setCookie("popup", 1, 1);
});

initPopup();

function initPopup() {
    var popup = getCookie("popup");
    if ($("#popup").length > 0) {
        var modal_popup = new bootstrap.Modal(document.getElementById("popup"));
        if (popup == 1) {
            modal_popup.hide();
        } else {
            modal_popup.show();
        }
    }
}

/* Inizializza Tooltip Bootstrap */
const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

/* Hack per svuotare i form dll'interno dei modal una volta che si ritorna dalla thankyou page */
document.querySelectorAll(".modal").forEach(function (modal) {
    modal.addEventListener("show.bs.modal", function () {
        if (window.performance.navigation.type === 2) {
            this.querySelector("form").reset();
        }
    });
});

/* Funzione Sroll_To */
function scroll_to(id, offset = "60", speed = "slow") {
    $("html,body").animate(
        {
            scrollTop: $("#" + id).offset().top - offset,
        },
        speed
    );
}

/* Funzione Sroll_To Top page */
$('.go-to-top-page').click(function(e) {
    e.preventDefault();
    $("html, body").animate({
        scrollTop: 0
    }, "fast");
    return false;
});

/* Quando da mobile si clicca sull'icona della ricerca avanzata, scrolla nel form di ricerca, se in home page in quello, altrimenti se nella lista nel form di ricerca */
$(".advanced_search").click(function () {
    if ($("#side-filters").length) {
        $(".closebyother").slideUp();
        scroll_to("side-filters");
    } else if ($("#form-hp").length) {
        $(".closebyother").slideUp();
        scroll_to("form-hp");
    }
});

/* Chiusura alternativa links mobile brands mobile e ricerca o links */
$("*[data-open]").click(function () {
    var classe = $(this).attr("data-open");
    var other = $(".closebyother").not("." + classe);
    $(".closebyother")
        .not("." + classe)
        .hide();
    $("." + classe).slideToggle();
});
/* Toggle dell'icona menu Hamburger */
$("a[data-open='menuvoci']").click(function () {
    $(".open_close_hamburger").toggle();
});
/* Chiude l'icona menu Hamburger se aperta quando apro menu ricerca */
$("a[data-open='menuloghi']").click(function () {
    if ($(".open_close_hamburger.not-active").is(":visible")) {
        $(".open_close_hamburger.not-active").css("display", "none");
        $(".open_close_hamburger.active").css("display", "block");
    }
});

/* Menu brands mobile e ricerca */
$("*[data-open-sub]").click(function () {
    var classe = $(this).attr("data-open-sub");
    var closeother = $(this).attr("data-closeother");
    if ($(this).hasClass("active")) {
        $("." + classe).slideToggle();
        $(".notactive").removeClass("active");
    } else {
        $(this).toggleClass("active");
        $(".notactive").not($(this)).removeClass("active");
        $("." + classe).slideDown("fast");
        $("." + closeother).slideUp("fast");
        $(".closesub")
            .not("." + classe)
            .slideUp("fast");
        $("." + classe).toggleClass("show");
    }
});
